module.exports = __webpack_public_path__ + "static/media/life_expectancy.1ceb5bd7.png";